<article class="landing-page" *ngIf="landingPage$() as page">
  <app-header-with-image
    *ngIf="(!!page.header.image.url || page.header.images?.length) && hasHeader$() && !isPlayPage$()"
    [header]="page.header"
    [inviewPort]="activeScrollTrigger$.value.includes('header')"
    (visible)="setNavTheme($event, !!page?.header?.darkHeader)"
    [randomTick]="randomTick"
  ></app-header-with-image>

  <app-header
    *ngIf="!page.header.image.url && !page.header.images?.length && hasHeader$() && !isPlayPage$()"
    [header]="page.header"
    [inviewPort]="activeScrollTrigger$.value.includes('header')"
  ></app-header>

  <app-header-play
    *ngIf="page.slug.toUpperCase() === 'PLAY'"
    [header]="page.header"
    [inviewPort]="activeScrollTrigger$.value.includes('header')"
  ></app-header-play>

  <main>
    <app-content-block-container
      [blocks]="page.contentBlocks"
      [activeScrollTrigger]="activeScrollTrigger$ | async"
      [hasHeader]="hasHeader$()"
      [hasDarkTheme]="isPlayPage$()"
    ></app-content-block-container>
  </main>
</article>
